export default class RequestPasswordReset {
  constructor(context) {
    this.context = context;
  }

  run(username) {
    this.context.gateways.authentication.requestPasswordReset(username);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/user/request_password_reset.js